import React from "react";
import { Route, useHistory } from "react-router";
import { Link } from "react-router-dom";

export const ProtectedRouteAdmin = (props) => {
  const history = useHistory();
  console.log("the props are here", props);
  if (localStorage.getItem("dhct_Token")) return <Route {...props} />;
  const login = () => {
    localStorage.clear();
    history.push("/");
  };
  return (
    <>
      <div>
        <p>You are not authorized to view this page.</p>{" "}
        <p>
          Please{" "}
          <Link to="/" onClick={login}>
            Login!
          </Link>
        </p>
      </div>
    </>
  );
};

export default ProtectedRouteAdmin;
